function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { SM } from "constants/sizes";
import { StyledSideBySideWithParagraphsParagraphComponent } from "./side-by-side-with-paragraphs-paragraph-component.scss";
import DefaultProps from "./default-props";
const SideBySideWithParagraphsParagraphComponent = (props)=>{
    const { primaryParagraph, leftSectionBottomText, leftSectionBottomTextColor, leftSectionParagraphAdvancedProps, rightSectionParagraphAdvancedProps, paragraphs } = props, restProps = _object_without_properties(props, [
        "primaryParagraph",
        "leftSectionBottomText",
        "leftSectionBottomTextColor",
        "leftSectionParagraphAdvancedProps",
        "rightSectionParagraphAdvancedProps",
        "paragraphs"
    ]);
    const rightSectionParagraphs = ()=>{
        return paragraphs.map((paragraph, index)=>{
            const { fullParagraph } = paragraph;
            return /*#__PURE__*/ _jsx("div", {
                className: "right-section-paragraph-wrapper",
                children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraph, rightSectionParagraphAdvancedProps))
            });
        });
    };
    const leftSection = ()=>{
        return /*#__PURE__*/ _jsxs("div", {
            className: "left-section-wrapper",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "full-paragraph-wrapper",
                    children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, primaryParagraph, leftSectionParagraphAdvancedProps))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "paragraph-wrapper",
                    children: /*#__PURE__*/ _jsx(Paragraph, {
                        body: leftSectionBottomText,
                        bodyColor: leftSectionBottomTextColor,
                        textSize: SM
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx(StyledSideBySideWithParagraphsParagraphComponent, {
        className: "side-by-side-with-paragraphs-paragraph-component",
        children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread({
            replaceAssetComponent: rightSectionParagraphs,
            replaceTextComponent: leftSection
        }, restProps))
    });
};
SideBySideWithParagraphsParagraphComponent.defaultProps = DefaultProps;
export default SideBySideWithParagraphsParagraphComponent;
